import React from "react";
import { Box, Typography, Grid } from "@mui/material";
import { motion } from "framer-motion";

export default function WhyItMatters() {
  return (
    <Box sx={{ py: 10, px: 2, bgcolor: "#f0f4f8" }}>
      <Grid container spacing={6} alignItems="center" justifyContent="center">
        <Grid item xs={12} md={6}>
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <Typography variant="h4" fontWeight="bold" gutterBottom>
              Why It Matters
            </Typography>
            <Typography variant="body1" sx={{ mb: 2 }}>
              After a kidney transplant, small changes in lab values can indicate big changes in your health.
              Tracking those values regularly — and spotting trends early — helps you and your care team act before issues become serious.
            </Typography>
            <Typography variant="body1">
              Our app brings clarity to your health data, offering you peace of mind, early warnings, and better communication with your doctor.
            </Typography>
          </motion.div>
        </Grid>

        <Grid item xs={12} md={5}>
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <Box
              component="img"
              src="https://images.unsplash.com/photo-1645685491865-42a4fbbc9912?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" // Replace with your own image
              alt="Why It Matters"
              sx={{ width: "25%", borderRadius: 4, boxShadow: 3}}
            />
          </motion.div>
        </Grid>
      </Grid>
    </Box>
  );
}